/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { FieldWellHeader } from "@components/sectionHeading";
import { useSetButtonText, useSetOnSubmitDefault } from "../../context/formContext/submitButton";
import { PrivacyConsentCheckbox, ReferralConsentCheckbox, MarketingConsentCheckbox } from "../../components/consentCheckbox";
import AddressField from "../../components/addressField";
import DependentCount from "../../components/dependentCount/dependentCount";
import ResidentialStatus from "../../components/residential/residentialStatus";
import ResidentialPayment from "../../components/residential/ResidentialPayment";
import { AnimatedToggle, withAnimatedHeight } from "@components/animatedHeight";
import Explain from "../../components/explain/explain";
import { TRUE_FALSE_VALUES, FIELD_NAMES } from "../../../../constants/commonConstants";
import YesNo from "../../components/yesNo/yesNo";
import MaritalStatus from "../../components/maritalStatus/maritalStatus";
import { PaddingTopMobile } from "@components/padding";
import { PaperWidthRow } from "@components/paper/paper";
import { MarginLeftRow, PaddingLeftCol } from "@components/leftGrid";
import PropTypes from "prop-types";
import { useSetDefaultValue } from "@hooks";
import ErrorWell from "@src/components/errorWell";
import styled from "styled-components";
import { size } from "styled-theme";

const AnimatedHeightCol = withAnimatedHeight(PaddingLeftCol);

const Wrapper = styled.div`
  .error-well-padding {
    padding: 0;
  }

  @media only screen and (min-width: ${size("S")}) {
    .error-well-padding {
      padding: 0 20px;
    }
  }
`;

const LivingSituationForm = (props) => {
  const {
    values: {
      acceptsPrivacyPolicy,
      marketingConsent,
      foreseeableChanges,
      loanReason
    } = {},
    errors,
    touched,
    handleChange,
    handleBlur,
    countryCodes,
    setFieldValue,
    setFieldTouched
  } = props;

  const { queryTheme, queryString: { utm_campaign, utm_source, utm_medium } } = useSelector((state) => state.StartUp);

  useSetOnSubmitDefault();
  useSetButtonText("Next");

  useSetDefaultValue(FIELD_NAMES.UTM_VALUES,  { [FIELD_NAMES.UTM_CAMPAIGN]: utm_campaign, [FIELD_NAMES.UTM_SOURCE]: utm_source, [FIELD_NAMES.UTM_MEDIUM]: utm_medium, [FIELD_NAMES.THEME]: queryTheme });

  useEffect(() => {
    if (foreseeableChanges === TRUE_FALSE_VALUES.FALSE)
      setFieldValueAndTouchStatus("foreseeableChangesExplain");
  }, [foreseeableChanges]);

  const setFieldValueAndTouchStatus = (
    fieldName,
    value = "",
    touchStatus = false
  ) => {
    setFieldValue(fieldName, value);
    setFieldTouched(fieldName, touchStatus);
  };

  let options = [];
  if (!!countryCodes && countryCodes.length > 0 && options.length === 0) {
    if (countryCodes.length > 0)
      countryCodes.forEach((country) => {
        options.push({
          value: country.code,
          label: `(${country.code})\t${country.countryName}`,
        });
      });
  }

  const showForeseeableChanges = foreseeableChanges === TRUE_FALSE_VALUES.TRUE;
  return (
    <Wrapper>
      <MarginLeftRow>
        <PaddingLeftCol xl={12}>
          <FieldWellHeader heading="Your Living Situation" asMobileHeader soft/>
          <div className="error-well-padding" ><ErrorWell errors={errors} touched={touched}/></div>
        </PaddingLeftCol>
      </MarginLeftRow>  
      <MarginLeftRow>
        <PaddingLeftCol xl={12}>
          <AddressField {...props} />
        </PaddingLeftCol>
      </MarginLeftRow>
      <PaddingTopMobile $padding="18" />
      <PaperWidthRow>
        <PaddingLeftCol sm={12} md={6}>
          <DependentCount/>
        </PaddingLeftCol>
        <PaddingLeftCol sm={12} md={6}>
          <MaritalStatus/>
        </PaddingLeftCol>
        <PaddingLeftCol sm={12} md={6}>
          <ResidentialStatus />
        </PaddingLeftCol>
        <AnimatedHeightCol sm={12} md={6}>
          <ResidentialPayment/>
        </AnimatedHeightCol>
      </PaperWidthRow>
      <PaperWidthRow>
        <PaddingLeftCol sm={12}>
          <YesNo/>
        </PaddingLeftCol>
      </PaperWidthRow>
      <PaperWidthRow> 
        <PaddingLeftCol sm={12}>
          <AnimatedToggle show={showForeseeableChanges}>
            <Explain hidden={!showForeseeableChanges} />
          </AnimatedToggle>
        </PaddingLeftCol>
      </PaperWidthRow>
      <PaperWidthRow>
          <PaddingLeftCol xl={12}>
            <PrivacyConsentCheckbox
              onChange={handleChange}
              onBlur={handleBlur}
              checked={acceptsPrivacyPolicy}
              name="acceptsPrivacyPolicy"
              setFieldValue={setFieldValue}
              loanReason={loanReason}
              errorMessage={
                touched.acceptsPrivacyPolicy ? errors.acceptsPrivacyPolicy : ""
              }
            />
          </PaddingLeftCol>
          <PaddingLeftCol xl={12}>
            <MarketingConsentCheckbox
              onChange={handleChange}
              onBlur={handleBlur}
              checked={marketingConsent}
              name="marketingConsent"
              setFieldValue={setFieldValue}
            />
          </PaddingLeftCol>
          <PaddingLeftCol sm={12}>
            <ReferralConsentCheckbox />
          </PaddingLeftCol>
      </PaperWidthRow>
    </Wrapper>
  );
};

export default LivingSituationForm;

LivingSituationForm.propTypes = {
  acceptsPrivacyPolicy: PropTypes.bool,
  marketingConsent: PropTypes.bool,
  foreseeableChanges: PropTypes.bool,
  loanAmount: PropTypes.number,
  loanReason: PropTypes.string,
  errors: PropTypes.object,
  touched: PropTypes.object,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  countryCodes: PropTypes.number,
  setFieldValue: PropTypes.func,
  setFieldTouched: PropTypes.func,
  values: PropTypes.object,
}